import * as React from 'react';
import MetricSetPairLoadStates from './metricSetPairLoadStates';
export default ({ result }) => {
    if (result) {
        return React.createElement(MetricSetPairLoadStates, null);
    }
    else {
        return React.createElement("h3", { className: "heading-3 text-center" }, "Select a metric result.");
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0cmljUmVzdWx0RGV0YWlsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2theWVudGEvcmVwb3J0L2RldGFpbC9tZXRyaWNSZXN1bHREZXRhaWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBRy9CLE9BQU8sdUJBQXVCLE1BQU0sMkJBQTJCLENBQUM7QUFVaEUsZUFBZSxDQUFDLEVBQUUsTUFBTSxFQUE0QixFQUFFLEVBQUU7SUFDdEQsSUFBSSxNQUFNLEVBQUU7UUFDVixPQUFPLG9CQUFDLHVCQUF1QixPQUFHLENBQUM7S0FDcEM7U0FBTTtRQUNMLE9BQU8sNEJBQUksU0FBUyxFQUFDLHVCQUF1Qiw4QkFBNkIsQ0FBQztLQUMzRTtBQUNILENBQUMsQ0FBQyJ9